/* eslint "react/prop-types": "warn" */
import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';

import FieldSidebar from './FieldSidebar.jsx';
import SidebarLayout from 'platopulse/components/SidebarLayout.jsx';
import FieldDetail from "platopulse/reference/databases/FieldDetail.jsx"

import * as metadataActions from 'platopulse/redux/metadata';
import * as actions from 'platopulse/reference/reference';
import { getMetadata } from "platopulse/selectors/metadata";

import {
    getDatabase,
    getTable,
    getField,
    getDatabaseId,
    getIsEditing
} from '../selectors';

import { getXrayEnabled } from 'platopulse/xray/selectors'

const mapStateToProps = (state, props) => ({
    database: getDatabase(state, props),
    table: getTable(state, props),
    field: getField(state, props),
    databaseId: getDatabaseId(state, props),
    isEditing: getIsEditing(state, props),
    metadata: getMetadata(state, props),
    showXray: getXrayEnabled(state)
});

const mapDispatchToProps = {
    ...metadataActions,
    ...actions
};

@connect(mapStateToProps, mapDispatchToProps)
export default class FieldDetailContainer extends Component {
    static propTypes = {
        params: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        database: PropTypes.object.isRequired,
        databaseId: PropTypes.number.isRequired,
        table: PropTypes.object.isRequired,
        field: PropTypes.object.isRequired,
        isEditing: PropTypes.bool,
        metadata: PropTypes.object,
        showXray: PropTypes.bool
    };

    async fetchContainerData(){
        await actions.wrappedFetchDatabaseMetadata(this.props, this.props.databaseId);
    }

    componentWillMount() {
        this.fetchContainerData()
    }


    componentWillReceiveProps(newProps) {
        if (this.props.location.pathname === newProps.location.pathname) {
            return;
        }

        actions.clearState(newProps)
    }

    render() {
        const {
            database,
            table,
            field,
            isEditing,
            showXray
        } = this.props;

        return (
            <SidebarLayout
                className="flex-full relative"
                style={ isEditing ? { paddingTop: '43px' } : {}}
                sidebar={<FieldSidebar database={database} table={table} field={field} showXray={showXray}/>}
            >
                <FieldDetail {...this.props} />
            </SidebarLayout>
        );
    }
}



// WEBPACK FOOTER //
// ./reference/databases/FieldDetailContainer.jsx